<template>
  <div id="app">
    <Header/>
  </div>
</template>

<script>
  import Header from './components/Header.vue'
  import * as Sentry from '@sentry/browser'

  var productionMode = window.location.host == "caseen.app";
  const prodDSN = "https://55d4f1950b334f799bece28a89e6bdd0@sentry.jpoles1.com/7"
  const devDSN = "https://a91f60a4e3404eb89db60ed0355350c7@sentry.jpoles1.com/8"
  Sentry.init({
    dsn: productionMode ? prodDSN : devDSN,
    environment: productionMode ? "prod" : "dev",
  })

  export default {
    name: 'app',
    components: { 
      Header
    },
    mounted: function () {
      if(window.location.host == "127.0.0.1:8080"){
        this.$store.commit("setLocalAPI")
      }
      if(this.$store.state.jwtClaims.email) {
        Sentry.configureScope((scope) => {
          scope.setUser({
            id: this.$store.state.jwtClaims.email,
            username: this.$store.state.jwtClaims.pid,
            email: this.$store.state.jwtClaims.email,
          });
        });
      }
      if(this.$store.state.jwtClaims.exp < Math.round((new Date()).getTime() / 1000)) {
        this.$store.commit("setJWTToken", undefined);
      }
    }
  }
</script>

<style>
html{
  overflow:hidden;
}
body{
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
hr{
  margin: 15px 0;
}
h1 {
  line-height: 100%;
}
.md-dialog {
  margin: auto;
}
</style>
